import { CommonStore } from '../common-store';

const storeModule = new CommonStore(
  'camp/areas',
  { name: 'camp.news' }
);

export default {
  namespaced: storeModule.namespaced,
  state: storeModule.state,
  getters: storeModule.getters,
  actions: storeModule.actions,
  mutations: storeModule.mutations
};
